import { createContext, useContext, useState } from 'react';

const dict = {
  it: {
    'nav.bag': 'Carrello',
    'promo.bar': '01 / CHROME — FIRST DROP',
    'hero.cta': 'Discover 01 →',
    'product.label': "L'object",
    'product.subtitle': 'Auricolari cablati in cromo',
    'product.tagline': 'JEWELRY THAT PLAYS MUSIC.',
    'product.desc':
      '01/CHROME trasforma un oggetto quotidiano in qualcosa da indossare. Superficie silver a specchio, filo a vista, zero custodie da ricaricare.',
    'product.outro': 'Plug in. Wear it out.',
    'product.dropPrice': 'FIRST DROP PRICE',
    'product.connector': 'Connettore',
    'pack.label': 'Il tuo pack',
    'pack.free': 'FREE SHIPPING',
    'pack.two': 'TWO OF US',
    'pack.twoSub': '2 × 01 / Chrome',
    'pack.shipWord': 'SPEDIZIONE',
    'pack.freeOver': 'Spedizione gratuita sopra i €50',
    'product.add': 'Aggiungi 01 →',
    'product.details': 'Dettagli',
    'product.detailsBody':
      'Superficie silver a specchio, cavo intrecciato silver (1,2 m), camera acustica chiusa in metallo. Connettore USB-C.',
    'product.compat': 'Compatibilità',
    'product.compatBody':
      'Funziona con qualsiasi dispositivo con porta USB-C. Nessuna batteria. Nessun pairing. Nessuna latenza.',
    'product.shipping': 'Spedizione e resi',
    'product.shippingBody':
      '01/CHROME è attualmente in produzione: spedizione in 15 giorni dall’ordine. Spedizione €4,90 — gratuita per ordini sopra €50. Resi entro 30 giorni dal ricevimento.',
    'preorder.title': 'FIRST DROP',
    'preorder.body':
      '01/CHROME è attualmente in produzione. Ordinalo ora al prezzo di lancio: 50% di sconto per chi entra nel primo drop e accetta di aspettare.',
    'preorder.shipping': 'Spedizione in 15 giorni dall’ordine.',
    'why.label': 'Why wired',
    'why.sub1': '01/CHROME è fatto per essere ascoltato. E visto.',
    'why.sub2':
      'Chrome a specchio. Filo a vista. Zero custodie da ricaricare.',
    'brand.label': 'Il brand',
    'brand.body':
      'Non tutto quello che compri deve servirti. Alcune cose devono semplicemente farti venire voglia di averle.',
    'brand.outro': '01/CHROME is the first one.',
    'final.drop': 'FIRST DROP',
    'cart.title': 'Carrello',
    'cart.empty': 'Il tuo carrello è vuoto.',
    'cart.continue': 'Continua a esplorare',
    'cart.add': 'Aggiungi',
    'cart.remove': 'Rimuovi',
    'cart.subtotal': 'Subtotale',
    'cart.note': 'Spedizione €4,90 — gratuita sopra €50. Calcolata al checkout',
    'cart.shippingNote': 'Spedizione in 15 giorni',
    'cart.checkout': 'Checkout',
    'cart.mock':
      'Il checkout Shopify si attiva appena vengono collegate le credenziali dello store',
    'footer.contact': 'Contatti',
    'footer.privacy': 'Privacy Policy',
    'footer.cookie': 'Cookie Policy',
  },
  en: {
    'nav.bag': 'Bag',
    'promo.bar': '01 / CHROME — FIRST DROP',
    'hero.cta': 'Discover 01 →',
    'product.label': 'The object',
    'product.subtitle': 'Chrome wired earphones',
    'product.tagline': 'JEWELRY THAT PLAYS MUSIC.',
    'product.desc':
      '01/CHROME turns an everyday object into something to wear. Mirror silver surface, visible wire, zero cases to charge.',
    'product.outro': 'Plug in. Wear it out.',
    'product.dropPrice': 'FIRST DROP PRICE',
    'product.connector': 'Connector',
    'pack.label': 'Your pack',
    'pack.free': 'FREE SHIPPING',
    'pack.two': 'TWO OF US',
    'pack.twoSub': '2 × 01 / Chrome',
    'pack.shipWord': 'SHIPPING',
    'pack.freeOver': 'Free shipping over €50',
    'product.add': 'Add 01 →',
    'product.details': 'Details',
    'product.detailsBody':
      'Mirror silver finish, braided silver cable (1.2 m), closed metal acoustic chamber. USB-C connector.',
    'product.compat': 'Compatibility',
    'product.compatBody':
      'Works with any device with a USB-C port. No battery. No pairing. No latency.',
    'product.shipping': 'Shipping & returns',
    'product.shippingBody':
      '01/CHROME is currently in production: ships in 15 days from your order. Shipping €4.90 — free over €50. 30-day returns from delivery.',
    'preorder.title': 'FIRST DROP',
    'preorder.body':
      '01/CHROME is currently in production. Order it now at the launch price — 50% off for everyone who joins the first drop and waits.',
    'preorder.shipping': 'Ships in 15 days from your order.',
    'why.label': 'Why wired',
    'why.sub1': '01/CHROME is made to be heard. And seen.',
    'why.sub2':
      'Mirror chrome. Visible wire. Zero cases to charge.',
    'brand.label': 'The brand',
    'brand.body':
      'Not everything you buy has to be useful. Some things should simply make you want them.',
    'brand.outro': '01/CHROME is the first one.',
    'final.drop': 'FIRST DROP',
    'cart.title': 'Bag',
    'cart.empty': 'Your bag is empty.',
    'cart.continue': 'Continue looking',
    'cart.add': 'Add',
    'cart.remove': 'Remove',
    'cart.subtotal': 'Subtotal',
    'cart.note': 'Shipping €4.90 — free over €50. Calculated at checkout',
    'cart.shippingNote': 'Ships in 15 days',
    'cart.checkout': 'Checkout',
    'cart.mock': 'Shopify checkout activates once the store credentials are connected',
    'footer.contact': 'Contact',
    'footer.privacy': 'Privacy Policy',
    'footer.cookie': 'Cookie Policy',
  },
};

const LangContext = createContext({ lang: 'it', setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('it');
  const t = (key) => dict[lang]?.[key] ?? dict.it[key] ?? key;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
